// extracted by mini-css-extract-plugin
export default {"wrapper":"summary_wrapper__GmEhU","stepper":"summary_stepper__Llwbo","opacity-transition":"summary_opacity-transition__R6-MK"};